import { ScmIntegrationsApi, scmIntegrationsApiRef, ScmAuth } from "@backstage/integration-react";
import {
  AnyApiFactory,
  BackstageIdentityApi,
  configApiRef,
  createApiFactory,
  createApiRef,
  discoveryApiRef,
  fetchApiRef,
  oauthRequestApiRef,
  OAuthApi,
  OpenIdConnectApi,
  ProfileInfoApi,
  SessionApi,
} from "@backstage/core-plugin-api";
import { OAuth2 } from "@backstage/core-app-api";
import { orchestratorApiRef, OrchestratorApiClient } from "@internal/plugin-orchestrator";

export const dexAuthApiRef = createApiRef<
  OAuthApi & OpenIdConnectApi & ProfileInfoApi & BackstageIdentityApi & SessionApi
>({
  id: "auth.dex",
});

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  createApiFactory({
    api: orchestratorApiRef,
    deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
    factory: ({ discoveryApi, fetchApi }) => new OrchestratorApiClient({ discoveryApi, fetchApi }),
  }),
  createApiFactory({
    api: dexAuthApiRef,
    deps: {
      discoveryApi: discoveryApiRef,
      oauthRequestApi: oauthRequestApiRef,
      configApi: configApiRef,
    },
    factory: ({ discoveryApi, oauthRequestApi, configApi }) =>
      OAuth2.create({
        discoveryApi,
        oauthRequestApi,
        configApi,
        provider: {
          id: "oidc",
          title: "Dex",
          icon: () => null,
        },
        defaultScopes: ["openid", "email", "groups", "profile", "offline_access"],
        environment: configApi.getOptionalString("auth.environment"),
      }),
  }),
  ScmAuth.createDefaultApiFactory(),
];
